export default "__VITE_ASSET__CmpOEoxF__"